import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "./Components/baseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
const LoginUserName = () => {
    useEffect(() => {
        document.title = "پایا | ورود";
    }, []);
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const getCode = (e) => {
        e.preventDefault();
        let data = new FormData();
        data.append("username", userName);
        let config = {
            method: "POST",
            url: `${baseUrl}/login`,
            data: data,
        };
        axios(config)
            .then((response) => {
                response.data &&
                    localStorage.setItem(
                        "user",
                        JSON.stringify(response.data.data)
                    );
                response.data &&
                    localStorage.setItem("token", response.data.data.token);
                // document.getElementById("to_home").click();
            })
            .catch(function (err) {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const loginHandler = (e) => {
        e.preventDefault();
        let data = new FormData();
        data.append("username", userName);
        data.append("password", password);
        data.append("notification_token", "ssss");

        let config = {
            method: "POST",
            url: `${baseUrl}/login`,
            data: data,
        };
        axios(config)
            .then((response) => {
                // response.data &&
                //     localStorage.setItem(
                //         "user",
                //         JSON.stringify(response.data.data)
                //     );
                // response.data &&
                //     localStorage.setItem("token", response.data.data.token);
                // document.getElementById("to_home").click();
            })
            .catch(function (err) {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    function refreshPage() {
        setTimeout(() => {
            window.location.reload(false);
        }, 100);
    }
    return (
        <div className="container">
            {/* <Link
                to={{ pathname: "/" }}
                id="to_home"
                onClick={refreshPage}
            ></Link> */}
            <form className="login-main">
                <img src="./assets/images/logo.svg" alt="" />
                <input
                    className="mb-20"
                    type="text"
                    name="username"
                    placeholder="نام کاربری"
                    id="username"
                    onChange={(e) => setUserName(e.target.value)}
                />
                <input
                    type="password"
                    name="password"
                    placeholder="رمز عبور"
                    id="password"
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button
                    onClick={loginHandler}
                    className="login-btn"
                    type="submit"
                    id="login-btn"
                >
                    ورود
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
                            stroke="white"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
                <a
                    onClick={() => navigate("/login")}
                    className="login-btn by-username"
                >
                    ورود با کد تایید
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
                            stroke="white"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </a>
            </form>
        </div>
    );
};

export default LoginUserName;
